import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import Home from "../views/Home/index.vue";
import SL from "../views/SL/index.vue";
import Recharge from "../views/recharge/yaychat_recharge.vue";
import Stripe from "../views/stripe/index.vue";
import Scheme from "../views/scheme.vue";
const routes = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/SL",
    component: SL,
  },
  {
    path: "/recharge",
    name: "recharge",
    component: Recharge,
  },
  {
    path: "/stripe",
    name: "stripe",
    component: Stripe,
  },
  {
    path:"/scheme",
    name:"scheme",
    component:Scheme,
  }
];

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes: routes,
});

export default router;
